import { $t } from '@/utils/languageAuto';
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading } from '@/decorators';

var AddEditModal = function (_super) {
  __extends(AddEditModal, _super);

  function AddEditModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.visible = false;
    _this.loading = false;
    _this.columns = [{
      title: _this.t('操作人'),
      dataIndex: 'create_user',
      filterEmpty: true
    }, {
      title: _this.t('操作类型'),
      dataIndex: 'oper_type_text',
      filterEmpty: true
    }, {
      title: _this.t('备注'),
      dataIndex: 'oper_content',
      width: 280,
      filterEmpty: true
    }, {
      title: _this.t('时间'),
      dataIndex: 'create_time',
      filterEmpty: true
    }];
    return _this;
  }

  AddEditModal.prototype.onVisibleChange = function (val) {
    if (val) {
      this.queryLogList();
    } else {
      this.dataList = [];
    }
  };

  AddEditModal.prototype.queryLogList = function () {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.wrapper.queryWrapperLogs({
              package_code: this.code
            })];

          case 1:
            data = _a.sent().data;
            this.dataList = data.list;
            return [2];
        }
      });
    });
  };

  __decorate([Prop({
    type: String,
    "default": ''
  })], AddEditModal.prototype, "code", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], AddEditModal.prototype, "onVisibleChange", null);

  __decorate([loading('loading')], AddEditModal.prototype, "queryLogList", null);

  AddEditModal = __decorate([Component], AddEditModal);
  return AddEditModal;
}(Vue);

export default AddEditModal;